<template>
  <div class="orders-returns">
    <div :class="stackClasses">
      <FirstContent
        v-if="0 >= slide"
        @next="next"
      />
      <SecondContent
        v-if="1 >= slide"
        @next="next"
        :max="max"
      />
      <ThirdContent :result="result" />
    </div>
  </div>
</template>

<script>
import { FirstContent, SecondContent, ThirdContent } from './content'

export default {
  name: 'OrdersReturns',
  data () {
    return {
      slide: 0,
      calc: {
        '0': 1,
        '1': 1
      }
    }
  },
  components: {
    FirstContent,
    SecondContent,
    ThirdContent
  },
  computed: {
    lastCard () {
      return Object.keys(this.cards).length - 1
    },
    stackClasses () {
      return {
        'stack': true,
        'state-first': this.slide === 0,
        'state-second': this.slide === 1,
        'state-third': this.slide === 2
      }
    },
    max () {
      return this.calc['0']
    },
    result () {
      if (!this.calc['0'] || this.calc['0'] === 0 || this.calc['1'] === 0) {
        return 0
      }
      if (this.calc['1'] > this.calc['0']) {
        return 100
      }
      return (this.calc['1'] / this.calc['0']) * 100
    }
  },
  methods: {
    zIndex (index) {
      return {
        zIndex: Object.keys(this.cards).length - index
      }
    },
    next (value) {
      this.calc[this.slide] = value
      this.slide++
    }
  }
}
</script>

<style lang="scss" scoped>
.stack {
  position: relative;
  height: 504px;
  margin-top: 2em;
  margin-bottom: 2em;
}

.state-first {
  .card:nth-child(2) {
    transform: translateY(20px) scale(0.95);
  }

  .card:last-child {
    transform: translateY(40px) scale(0.9);
  }
}

.state-second {
  .card:nth-child(2) {
    transform: translateY(0) scale(1);
  }

  .card:last-child {
    transform: translateY(20px) scale(0.95);
  }
}
</style>
